import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';

const Donatebcontent = () => {
  return (
    <Box
      sx={{
        backgroundColor: '#065f4f',
        color: 'white',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        px: { xs: 3, sm: 6 },      // less padding on mobile
        py: { xs: 3, sm: 4 },
        minHeight: { xs: 'auto', sm: '150px' },
        flexDirection: { xs: 'column', sm: 'row' }, // stack on xs
        gap: { xs: 2, sm: 0 },    // gap between stacked items on mobile
        textAlign: { xs: 'center', sm: 'left' },
      }}
    >
      {/* Left Text */}
      <Typography
        variant="h5"
        sx={{
          fontWeight: 'bold',
          fontSize:{md:'30px',xs:'20px'},
          maxWidth: { xs: '100%', sm: '60%' },
          lineHeight: 1.2,
          fontFamily: "Montserrat, sans-serif",
        }}
      >
        Together we can build a more just, <br />
        equitable and sustainable future.
      </Typography>

      {/* Right Button */}
      <Button
        variant="outlined"
        sx={{
          borderRadius: '50px',
          borderColor: 'white',
          backgroundColor: '#b1cc34',
          color: 'white',
          fontWeight: 'bold',
          px: 4,
          py: 1.5,
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          width: { xs: '100%', sm: '250px' },  // full width on mobile
          maxWidth: 350,
          '&:hover': {
            backgroundColor: '#a1b92d',
            borderColor: 'white',
          },
        }}
      >
        <Box
          sx={{
            flex: 1,
            textAlign: 'left',
            fontFamily: "Montserrat, sans-serif",
          }}
        >
          Indian Donor
        </Box>
        <CurrencyRupeeIcon sx={{ color: 'white' }} />
      </Button>
    </Box>
  );
};

export default Donatebcontent;
